<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1101001000012ogcbd.vue
*@ 컴포넌트설명 :[베트남] 예금 상품 > 예금 상품 상세(기업당좌예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <section class="deposit detail">
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>기업당좌예금</h2>
          </div>
          <div class="description">
            <p>
              기업당좌 결제용 입출금이 자유로운 통장
            </p>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품유형</dt>
            <dd>당좌예금</dd>
            <dt>상품개요</dt>
            <dd>기업당좌 결제용 입출금이 자유로운 통장</dd>
            <dt>가입대상</dt>
            <dd>캄보디아 법인</dd>
            <dt>계약기간</dt>
            <dd>제한없음</dd>
            <dt>가입통화</dt>
            <dd>USD, KHR</dd>
            <dt>가입금액</dt>
            <dd>신규가입 시 최저 USD 1,000.00 이상</dd>
            <dt>금리 및 이율</dt>
            <dd>약정이율 연 0.00% (USD 및 KHR 공통적용)</dd>
            
            <dt>수수료</dt>
            <dd>해당무</dd>
            
            <dt>가입방법</dt>
            <dd>영업점가입</dd>
            
            <dt>가입시 필요서류</dt>
            <dd>대표자 내점시 : 사업허가증, 법인등기부등본, 사업자등록증, 정관, 주총결의서, 여권 사본 등<br>
            대리인 내점시 : 사업허가증, 법인등기부등본, 사업자등록증, 정관, 주총결의서, 여권 사본, 위임장 및 대리인 실명확인증<br>
            · 위임장에는 신청직원의 인적사항 및 위임내용이 기재되어야 하며, 법인인감날인이 필요합니다.
            </dd>
          </dl>
        </article>
      </div>
    </template>
    <template v-else-if="lang == $config.LANG_ENG">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>Corporate Checking Account</h2>
          </div>
          <div class="description">
            <p>
              Saving with free deposit and withdrawal by using slip and check book for enterprise.
            </p>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Types</dt>
            <dd>Checking Account</dd>
            <dt>About the products</dt>
            <dd>Saving with free deposit and withdrawal by using slip and check book for enterprise.</dd>
            <dt>Eligibilty</dt>
            <dd>Enterprise</dd>
            <dt>Contract Terms</dt>
            <dd>No restrictions</dd>
            <dt>Available currency</dt>
            <dd>USD, KHR</dd>
            <dt>Deposit amount</dt>
            <dd>To open a new account, deposit a minimum of USD 1,000.00</dd>
            <dt>Rates</dt>
            <dd>Agreed interest rate of 0.00% annually (for both USD and KHR)</dd>
            
            <dt>Fees</dt>
            <dd>N/A</dd>
            
            <dt>How to apply</dt>
            <dd>Apply at the branch</dd>
            
            <dt>Required documents for application</dt>
            <dd>
              When a representative visits : business license, certified copy of corporate registration, business registration card, articles of incorporation, written resolution of general stockholders meeting, a copy of passport, etc.<br>
              When a surrogate visits : business license, certified copy of corporate registration, business registration certificate, articles of incorporation, written resolution of general stockholders meeting, a copy of passport, a letter of attorney and surrogate's ID<br>
            · A letter of attorney is required to have a surrogate's personal information and contents of dlegation, and corporate seal
            </dd>
          </dl>
        </article>
      </div>
    </template>
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>គណនីចរន្តសំរាប់ក្រុមហ៊ុន</h2>
          </div>
          <div class="description">
            <p>
              គណនីដែលអាចសន្សំ និងដកប្រាក់ដោយប្រើប័ណ្ណរឺមូលប្បទានប័ត្រសំរាប់សហគ្រាស
            </p>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>ប្រភេទផលិតផល</dt>
            <dd>Checking Account</dd>
            <dt>មាតិកាផលិតផល</dt>
            <dd>គណនីដែលអាចសន្សំ និងដកប្រាក់ដោយប្រើប័ណ្ណរឺមូលប្បទានប័ត្រសំរាប់សហគ្រាស</dd>
            <dt>អតិថិជនគោលដៅ</dt>
            <dd>សហគ្រាស</dd>
            <dt>រយៈពេលកិច្ចសន្យា</dt>
            <dd>មិនមានកំនត់</dd>
            <dt>ប្រភេទរូបិយប័ណ្ណដែលស្នើសុំ</dt>
            <dd>USD, KHR</dd>
            <dt>ចំនួនទឹកប្រាក់ដែលស្នើសុំ</dt>
            <dd>ចំនួនទឹកប្រាក់ដំបូងតិចបំផុត USD1,000.00</dd>
            <dt>អត្រាការប្រាក់</dt>
            <dd>ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ0.00% (ប្រាក់រៀលនិងប្រាក់ដុល្លាគិតដូចគ្នា)</dd>
            <dt>កំរៃសេវា</dt>
            <dd>គ្មាន</dd>
            <dt>របៀបចុះឈ្មោះ</dt>
            <dd>ចុះឈ្មោះនៅសាខា</dd>
            <dt>តំរូវការឯកសារចុះឈ្មោះ</dt>
            <dd>- លិខិតអនុញ្ញាតបើកអាជីវកម្ម<br>
                - អាជ្ញាប័ណ្ណប្រកបអាជីវកម្ម និង ប័ណ្ណប៉ាតង<br>
                ់ - សេចក្ដីសម្រេចរបស់ក្រុមប្រឹក្សាភិបាល<br>
                - ក្ខន្តិកៈក្រុមហ៊ុន<br>
                - អត្ដសញ្ញាណប័ណ្ណ រឺ លិខិតឆ្លងដែនច្បាប់ដើមរបស់អភិបាល និង អ្នកទទួលសិទ្ឋិប្រសិនមាន។
            </dd>
          </dl>
        </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed:{
    ...mapFields(["lang"]),
  }
};
</script>
